export default __webpack_public_path__ + "static/mejszutowicz-2f16b0f0bc809dba0b124f62e31c7aaf.jpg";